import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractDataProvider } from '../AbstractDataProvider';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { forkJoin, Observable, Subject } from 'rxjs';
import {
  GridComponent, RowClassArgs
} from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { ActivatedRoute } from '@angular/router';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { GenericFilterModel } from '../security/QueryStringParam';
import { READ_FILTERS, TIME_FILTERS } from '../../shared/staticData/filters-data';
import { FilterModel, Fund, ResponseModel, TimeFilter } from '../../shared/model/interfaces';
import { debounceTime, finalize, } from 'rxjs/operators';
import {getErrorMessageText} from '../helper';

@Component({
  selector: 'app-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss']
})
export class InboxComponent implements OnInit {

  @ViewChild(GridComponent) kendoGridComponent: GridComponent;
  @ViewChild('txtFromDistDate') txtFromDistDate;
  @ViewChild('txtToDistDate') txtToDistDate;
  public sort: SortDescriptor[] = [{
    field: 'ActiveOn',
    dir: 'desc'
  }];
  display = false;
  alertMessage: string;
  totalRecords: number;
  public loading: boolean;
  public rowPerPage = 50;
  public currentPageNo = 1;
  public data: Observable<any>;
  public inbox = [];
  public forWhat = 'all';
  public fund = '0';
  public fileType = '0';
  daysToGoBack = 'P6M';
  messageSearchText = '';
  downloadDocumentImagUrl: string = this.abstractDataProvider.baseUrl + 'api/File/FileDownloadFromDocumentImage?SeqNum=';
  public IsAll = false;
  public IsUnread = false;
  public IsRead = false;
  public IsAnnouncementMode = false;
  heightOfGridContainer = 200;
  skipRecords = 0;
  public funds: Fund[] = [];
  public fileTypeList = [];
  readFilters: FilterModel[] = READ_FILTERS;
  timeFilters: TimeFilter[] = TIME_FILTERS;
  private allDataLoaded = false;
  private textChanged = new Subject();

  constructor(private abstractDataProvider: AbstractDataProvider, private authService: AuthServiceCustom, private ngxService: NgxUiLoaderService, private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.route.queryParams.subscribe(queryParam => {
      for (const key in queryParam) {
        if (key === 'mode') {
          this.forWhat = queryParam[key];
          if (this.forWhat === 'announcement') {
            this.IsAnnouncementMode = true;
          }
        } else if (key === 'type') {
          this.fileType = 'CONF';
        }
      }
      this.search();
    });
    this.heightOfGridContainer = this.authService.heightOfPageContainer - 160;
    forkJoin([this.abstractDataProvider.getData('api/Fund/GetFunds'), this.abstractDataProvider.getData('api/Inbox/GetFileTypes')])
      .subscribe(([funds, fileTypesData]) => {
          this.ngxService.stop();
          this.funds = funds.Funds;
          this.fileTypeList = fileTypesData.FileTypes;
        },
        error => {
          this.ngxService.stop();
          this.display = true;
          this.alertMessage =  getErrorMessageText(error);
        });

    this.textChanged.pipe(debounceTime(300)).subscribe(() => this.search());
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.search();
  }

  loadMore(event: any) {
    if (!this.allDataLoaded && !this.loading) {
      this.skipRecords = this.inbox.length;
      this.loading = true;
      this.makeAPICallGetData();
    }
  }

  makeAPICallGetData() {
    const genericFilterModel = new GenericFilterModel();
    genericFilterModel.Filters = [];

    genericFilterModel.PageNo = this.currentPageNo;
    genericFilterModel.PageSize = this.rowPerPage;
    genericFilterModel.SortField = this.sort[0].field;
    genericFilterModel.SortOrder = this.sort[0].dir;
    genericFilterModel.SkipRecords = this.skipRecords;

    genericFilterModel.Filters.push({Key: 'forWhat', Value: this.forWhat});
    genericFilterModel.Filters.push({Key: 'fund', Value: this.fund});
    genericFilterModel.Filters.push({Key: 'fileType', Value: this.fileType});
    genericFilterModel.Filters.push({Key: 'daysToGoBack', Value: this.daysToGoBack});
    if (this.daysToGoBack === 'DR') {
      genericFilterModel.Filters.push({Key: 'txtFromDistDate', Value: this.txtFromDistDate.Value});
      genericFilterModel.Filters.push({Key: 'txtToDistDate', Value: this.txtToDistDate.Value});
    }
    genericFilterModel.Filters.push({Key: 'messageSearchText', Value: this.messageSearchText});

    this.abstractDataProvider.postData(genericFilterModel, 'api/Inbox/GetInbox')
      .pipe(
        finalize(() => this.loading = false))
      .subscribe((inbox: ResponseModel<any>) => {
          if (genericFilterModel.SkipRecords === 0) {
            this.totalRecords = inbox.TotalCount;
          }
          if (inbox.Data.length > 0) {
            this.inbox = [...this.inbox, ...inbox.Data];
            if (this.totalRecords === this.inbox.length) {
              this.allDataLoaded = true;
            }
          } else {
            this.allDataLoaded = true;
          }
        },
        error => {
          this.display = true;
          this.alertMessage = getErrorMessageText(error);
        });
  }

  downloadDocument(DocSeqNum: any, FileNum: any) {

    this.abstractDataProvider.getData('api/File/IsFileExist?SeqNum=' + DocSeqNum + '&forWhat=form')
      .subscribe(
        posts => {
          if (posts.Message) {
            this.display = true;
            this.alertMessage = posts.Message;
          } else if (posts.DocSeqNum) {
            // window.open(this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum, '_blank');
            const url = this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum;
                this.abstractDataProvider.downloadFile(url)
                .subscribe(_ => {}, error =>{
                  this.display = true;
                  this.alertMessage = getErrorMessageText(error);
                });
          } else {
            // Not Found
            this.display = true;
            this.alertMessage = 'File not found.';
          }
        },
        error => {
          this.ngxService.stop();
          if (error.error && error.error.error_description) {
            this.display = true;
            this.alertMessage = error.error.error_description;
          } else {
            this.alertMessage = error.message;
          }
        }
      );
  }

  public rowCallback = (context: RowClassArgs) => {
    switch (context.dataItem.ReadFlag) {
      case 'N':
        return {gold: true};
      default:
        return {};
    }
  };

  onConfirm() {
    this.display = false;
  }

  selectInboxTypeLink(forWhat) {
    this.forWhat = forWhat;
    this.search();
  }

  onTextChanged(): void {
    this.textChanged.next();
  }

  search() {
    if (this.daysToGoBack === 'DR') {
      if (!this.txtFromDistDate || !this.txtFromDistDate.Value || !this.txtToDistDate.Value) {
        return;
      }
    }
    this.currentPageNo = 1;
    this.allDataLoaded = false;
    this.inbox = [];
    this.loading = true;
    this.skipRecords = 0;
    this.makeAPICallGetData();
  }
}
